let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eJOes")).then(() => parcelRequire('hp07f'));